import React, { useState, useEffect } from "react";
import { GenericButton } from "../../components/common/GenericButton";
import { ToggleIcon } from "../../components/common/ToggleIcon";
import { toast } from "react-toastify";

export const Password = ({ onDataComplete, context, data }) => {
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [icon, setIcon] = useState();
	const [disableSaveButton, setDisableSaveButton] = useState(true);
	const minPwd = 8;
	const maxPwd = 32;

	const handleReset = () => {
		setPassword("");
		setConfirmPassword("");
		setIcon();
		setDisableSaveButton(true);
	};

	const passwordChange = (e) => {
		const value = e.target.value.trim();
		setPassword(value);

		if (confirmPassword && value) {
			if (confirmPassword === value) {
				setIcon("tick");
				setDisableSaveButton(false);
			} else {
				setIcon("cross");
				setDisableSaveButton(true);
			}
		} else {
			setIcon();
			setDisableSaveButton(true);
		}
	};

	const confirmPasswordChange = (e) => {
		const value = e.target.value.trim();
		setConfirmPassword(value);

		if (password && value) {
			if (password === value) {
				setIcon("tick");
				setDisableSaveButton(false);
			} else {
				setIcon("cross");
				setDisableSaveButton(true);
			}
		} else {
			setIcon();
			setDisableSaveButton(true);
		}
	};

	const handleSaveClick = () => {
		const validatePassword = (pwd) => {
			return pwd.length >= minPwd && pwd.length <= maxPwd;
		};

		let text;
		let type;

		if (validatePassword(password)) {
			type = "success";
			text = (
				<>
					<p className="mb-2">Your password has been saved.</p>
					<p className="mb-2">Now record your personal details.</p>
				</>
			);

			onDataComplete(context, {
				password,
				confirmPassword,
			});
		} else {
			type = "warning";
			text = (
				<>
					<p className="mb-2">Your password could not be saved.</p>
					<p className="mb-2">
						It needs to be between {minPwd} and {maxPwd} characters and yours is{" "}
						{password.length} long.
					</p>
				</>
			);
		}

		toast(text, { type, hideProgressBar: true });
	};

	useEffect(() => {
		if (!data) {
			return;
		}

		setPassword(data.password);
		setConfirmPassword(data.confirmPassword);
		setDisableSaveButton(false);
	}, [data]);

	return (
		<div className={"text-sm lg:text-base"}>
			<h2 className={`text-2xl font-bold mb-2 text-center pt-2`}>Password</h2>

			<div className={"flex-grow pt-2 sm:pt-8"}>
				<div className={"mb-2"}>
					<p className={"mb-3"}>Please choose a password.</p>
					<p className={"mb-3"}>
						Your password must be at least {minPwd} characters and no more than{" "}
						{maxPwd} characters, and may not start or end with a space. Your
						password should be memorable to you but not easy to guess.
					</p>
					<p className={"mb-3"}>
						You can always change your password at a later time: whenever you
						sign in to Your Health Companion just follow the "Forgotten
						password" link.
					</p>
					<div
						className={
							"w-full mx-auto space-y-2 pb-4 border-b-2 border-white border-opacity-50"
						}
					></div>
				</div>

				<div className={"formInputContainer"}>
					<label className={"basicFormLabel"} htmlFor={"password"}>
						Password<sup>*</sup>:
					</label>
					<input
						type="text"
						className={"formField"}
						id="password"
						name="password"
						value={password}
						onChange={passwordChange}
						placeholder="Password"
					/>
				</div>
				<div className={"formInputContainer mb-6"}>
					<label className={"basicFormLabel"} htmlFor={"confirmpassword"}>
						Confirm<sup>*</sup>:
					</label>
					<div className="relative">
						<input
							type="text"
							className={"formField"}
							id="confirmepassword"
							name="confirmpassword"
							value={confirmPassword}
							onChange={confirmPasswordChange}
							placeholder="Confirmation"
						/>
						<ToggleIcon
							selection={icon}
							classes="ml-2 text-xl absolute right-2 top-3"
							colours={{ tick: "green", cross: "red" }}
						/>
					</div>
				</div>

				<div className={"flex gap-3 max-w-xs mx-auto"}>
					<div className={"w-1/2"}>
						<GenericButton
							text="Clear"
							onClick={handleReset}
							classes="inactive-button"
						/>
					</div>
					<div className={"w-1/2"}>
						<GenericButton
							text="Save"
							disabled={disableSaveButton}
							onClick={handleSaveClick}
							classes="active-button"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
